<template>
  <div id="dossiersWrapper">
    <div class="tabs no-print">
      <ul>
        <li :class="{ 'is-active': this.$route.name === 'dossiers' }"><router-link :to="{ name: 'dossiers'}" class="navbar-item">Lijst</router-link></li>
        <li :class="{ 'is-active': this.$route.name === 'diff-dossiers' }"><router-link :to="{ name: 'diff-dossiers'}" class="navbar-item">Vergelijker</router-link></li>
      </ul>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>
